/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_09b7fdbf"]'><cube-float-ball @_click="handleClick"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/TRSp1qfRVjgrDF9Lr-OyN_service-assist.png" :class='["float-ball-demo"]'></mpx-image></cube-float-ball></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_09b7fdbf"}'>
.float-ball-demo
  width 50px
  height 50px
  border-radius 50%
  box-shadow 0 1px 12px rgba(0, 0, 0, .2)
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_09b7fdbf"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_09b7fdbf"}
  /** script content **/
  require("./float-ball-slot.mpx.js?isComponent&outputPath=components%2Ffloat-ball-slot09b7fdbf%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./float-ball-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ffloat-ball-slot09b7fdbf%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_09b7fdbf"],
    ctorType: "component",
    outputPath: "components/float-ball-slot09b7fdbf/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-float-ball':getComponent(require("../../../packages/mpx-cube-ui/src/components/float-ball/index.mpx?isComponent&outputPath=components%2Findexe1137352%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>